import { TrialDto } from "@decibeltrade/sdk";
import { useState } from "react";

import { useUserPositionsQuery } from "@/contexts/queries/user-positions";
import { getServerTime } from "@/utils/server-time";

/**
 * Freeze signal: the trial subaccount's positions feed confirms flat — fires
 * on whoever's close lands, stays live through partial fills (settles can
 * repeat). No-position counts as flat only after a position was observed or
 * past expiry — a not-yet-filled trial must not freeze at mount.
 */
export function useTrialPositionFlat(trial: TrialDto | null): boolean {
  const isActive = trial?.status === "Active";
  const positionsQuery = useUserPositionsQuery({
    subAddr: isActive ? trial.trial_subaccount : undefined,
  });

  const [observedOpenFor, setObservedOpenFor] = useState<string | null>(null);
  if (!isActive || !positionsQuery.isSuccess) return false;

  const trialKey = `${trial.campaign_addr}:${trial.trial_id}`;
  const size = positionsQuery.data.find((p) => p.market === trial.market)?.size ?? 0;
  if (size !== 0) {
    if (observedOpenFor !== trialKey) setObservedOpenFor(trialKey);
    return false;
  }

  const pastExpiry = trial.expires_at_ms !== undefined && getServerTime() >= trial.expires_at_ms;
  return observedOpenFor === trialKey || pastExpiry;
}
